var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResumeSeparationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.501 16.4985H22.501C20.8441 16.4985 19.501 17.8417 19.501 19.4985V58.4985C19.501 60.1554 20.8441 61.4985 22.501 61.4985H58.501C60.1578 61.4985 61.501 60.1554 61.501 58.4985V19.4985C61.501 17.8417 60.1578 16.4985 58.501 16.4985Z",
    fill: "#73A9EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.501 10.4993H13.501C11.8441 10.4993 10.501 11.8424 10.501 13.4993V52.4993C10.501 54.1561 11.8441 55.4993 13.501 55.4993H49.501C51.1578 55.4993 52.501 54.1561 52.501 52.4993V13.4993C52.501 11.8424 51.1578 10.4993 49.501 10.4993Z",
    fill: "#94C6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4395 40.125C42.5785 40.125 43.502 39.2016 43.502 38.0625C43.502 36.9234 42.5785 36 41.4395 36H21.5644C20.4254 36 19.5019 36.9234 19.5019 38.0625C19.5019 39.2016 20.4254 40.125 21.5644 40.125H41.4395Z",
    fill: "#D1E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4395 48C42.5785 48 43.502 47.0766 43.502 45.9375C43.502 44.7984 42.5785 43.875 41.4395 43.875H21.5644C20.4254 43.875 19.5019 44.7984 19.5019 45.9375C19.5019 47.0766 20.4254 48 21.5644 48H41.4395Z",
    fill: "#D1E6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5048 24.5175C33.3046 24.5175 34.7636 23.0585 34.7636 21.2587C34.7636 19.459 33.3046 18 31.5048 18C29.7051 18 28.2461 19.459 28.2461 21.2587C28.2461 23.0585 29.7051 24.5175 31.5048 24.5175Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1665 31.4995H26.8365C26.6189 31.5008 26.404 31.4518 26.2086 31.3562C26.0132 31.2607 25.8425 31.1212 25.7099 30.9487C25.5774 30.7762 25.4865 30.5753 25.4445 30.3619C25.4025 30.1484 25.4104 29.9282 25.4677 29.7183C25.886 28.4482 26.6944 27.3424 27.7778 26.5586C28.8612 25.7748 30.1643 25.3528 31.5015 25.3528C32.8387 25.3528 34.1418 25.7748 35.2252 26.5586C36.3086 27.3424 37.117 28.4482 37.5352 29.7183C37.5925 29.9282 37.6005 30.1484 37.5584 30.3619C37.5164 30.5753 37.4256 30.7762 37.293 30.9487C37.1605 31.1212 36.9898 31.2607 36.7944 31.3562C36.5989 31.4518 36.384 31.5008 36.1665 31.4995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResumeSeparationBlue);
export default __webpack_public_path__ + "static/media/icon_resume_separation_blue.f7b36b03.svg";
export { ForwardRef as ReactComponent };